import { ModalWindow } from '@cian/ui-kit/modal';
import { Header4, InlineText2, Paragraph2 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import { TDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';

const styles = require('./CookieAgreementModal.css');

interface ICookieAgreementModal {
  isOpen: boolean;
  deviceType: TDeviceType;

  onClose(): void;
  onAccept(): void;
}

export const CookieAgreementModal: React.FC<ICookieAgreementModal> = ({ isOpen, deviceType, onClose, onAccept }) => {
  const isPhone = deviceType === 'phone';
  const buttonSize: TButtonSize = isPhone ? 'M' : 'XS';
  const cancelButtonTheme: TButtonTheme = isPhone ? 'fill_secondary' : 'fill_white_primary';

  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      title="Соглашение об использовании cookie-файлов"
      maxWidth={928}
      size="M"
      fixed
      content={
        <>
          <div className={styles['subtitle']}>
            <Header4>1. Общие сведения</Header4>
          </div>
          <div className={styles['text-section']}>
            <Paragraph2>
              На Сайтах Циан и мобильном приложении Циан (далее - Сайты Циан) применяется технология сбора информации с
              использованием cookie-файлов, которая позволяет повысить эффективность Сайтов, Сервисов Циан. Сookie-файлы
              - это небольшие текстовые файлы, размещаемые на пользовательском устройстве веб-сайтами, которые
              посещались пользователем. Они широко используются для того, чтобы веб-сайты могли работать эффективнее, а
              также, чтобы предоставлять необходимую информацию владельцам, администрации веб-сайта. Использование
              cookie-файлов - стандартная на данный момент практика для большинства веб-сайтов. Посещая Сайты Циан
              пользователь соглашается с условиями использования cookie-файлов, описанными в настоящем документе, в том
              числе с тем, что ООО «Айриэлтор» (Адрес: 107023, г. Москва, ул. Электрозаводская, д.27 стр.8, пом. I, этаж
              5, ОГРН 1137746481190) может использовать cookie-файлы и иные данные для их последующей обработки, а также
              может передавать их третьим лицам для проведения исследований и предоставления услуг Партнерами Циан.
            </Paragraph2>
          </div>

          <div className={styles['subtitle']}>
            <Header4>2. Цели использования cookie-файлов</Header4>
          </div>
          <div className={styles['list-title']}>
            <Paragraph2>Целями использования cookie-файлов на Сайтах Циан являются:</Paragraph2>
          </div>
          <ul className={styles['list']}>
            <li>
              <InlineText2>
                повышение удобства использования Сайтов Циан (оптимизация структуры и содержимого Сайтов Циан);
              </InlineText2>
            </li>
            <li>
              <InlineText2>персонализация взаимодействия (таргетированная реклама объявлений);</InlineText2>
            </li>
            <li>
              <InlineText2>
                оптимизация сервисов, услуг на сайте Циан в соответствии с интересами и потребностями пользователей;
              </InlineText2>
            </li>
            <li>
              <InlineText2>создание профиля пользователей;</InlineText2>
            </li>
            <li>
              <InlineText2>идентификации пользователей;</InlineText2>
            </li>
            <li>
              <InlineText2>оценка эффективности рекламных кампаний.</InlineText2>
            </li>
          </ul>
          <div className={styles['text-section']}>
            <Paragraph2>
              Для достижения указанных целей, собираемые данные могут передаваться Партнерам Циан, которые оказывают
              помощь Циан в предоставлении услуг. К категориям таких получателей относятся: веб-аналитика, обработка
              данных, реклама, информационные и рекламные рассылки и другие услуги.
            </Paragraph2>
          </div>

          <div className={styles['subtitle']}>
            <Header4>3. Прекращение использования cookie-файлов</Header4>
          </div>
          <div className={styles['list-title']}>
            <Paragraph2>На Сайтах ЦИАН используются cookie-файлы двух разных типов:</Paragraph2>
          </div>
          <ul className={styles['list']}>
            <li>
              <InlineText2>
                сеансовые cookie-файлы. Это временные файлы cookie, которые хранятся на устройстве пользователя до того
                момента, когда пользователь покидает Сайт Циан;
              </InlineText2>
            </li>
            <li>
              <InlineText2>
                постоянные cookie-файлы. Эти cookie-файлы остаются на устройстве пользователя на длительный срок или
                вплоть до момента их ручного удаления.
              </InlineText2>
            </li>
          </ul>
          <div className={styles['list-title']}>
            <Paragraph2>Прекращение использования cookie-файлов на Сайтах Циан возможно путем:</Paragraph2>
          </div>
          <ul className={styles['list']}>
            <li>
              <InlineText2>отключения использования cookie-файлов в настройках веб-браузера;</InlineText2>
            </li>
            <li>
              <InlineText2>отказа от использования Сайтов Циан. </InlineText2>
            </li>
          </ul>
          <div className={styles['text-section']}>
            <Paragraph2>
              Отключение используемых Сайтами Циан cookie-файлов может привести к снижению удобства использования
              Сайтами Циан. Большинство браузеров позволяют просматривать, удалять и блокировать cookie-файлы c
              веб-сайтов. Информация по управлению cookie-файлами может быть найдена в документации на используемый
              браузер.
            </Paragraph2>
          </div>
        </>
      }
      footer={
        <div className={styles['footer-container']}>
          <Button onClick={onClose} theme={cancelButtonTheme} size={buttonSize} fullWidth={isPhone}>
            Отменить
          </Button>
          <Button onClick={onAccept} theme="fill_primary" size={buttonSize} fullWidth={isPhone}>
            Принять
          </Button>
        </div>
      }
    />
  );
};

CookieAgreementModal.displayName = 'CookieAgreementModal';
